// extracted by css-extract-rspack-plugin
module.exports =  {"emphasize":"ConfirmNewTransactionModal__emphasize___hsCGo"};